import { ReactComponent as StatusIcon } from '@assets/components/panel/monitoring/status.svg';
import { IcWorks16 } from '@assets/icons/16x16';
import { CheckboxFilterItem } from '@components/cockpit/panels/CheckboxListFilter';
import { CriticalityCategoryEnum, statusCategoryColor } from '@components/cockpit/panels/monitoring/monitoring.types';

export const getStatusFilterCheckboxItems = (
  isChecked: (status: CriticalityCategoryEnum) => boolean,
  onChange: (status: CriticalityCategoryEnum) => void,
  countByStatusFilter: Record<CriticalityCategoryEnum, number>,
): CheckboxFilterItem[] =>
  Object.values(CriticalityCategoryEnum).map((status) => ({
    label: `components.monitoring.filter.status.${status}`,
    checked: isChecked(status),
    icon: status === CriticalityCategoryEnum.MAINTENANCE ? IcWorks16 : StatusIcon,
    iconColor: statusCategoryColor[status],
    count: countByStatusFilter[status],
    onChange: () => onChange(status),
  }));
